import React from 'react';
import PolicyLayout from '../components/PolicyLayout';
import SEOHead from '../components/SEOHead';
import { getSEOConfig } from '../utils/seoConfig';

const TermsOfUsePage: React.FC = () => {
  const seoConfig = getSEOConfig('/terms');

  return (
    <>
      <SEOHead
        title={seoConfig.title}
        description={seoConfig.description}
        keywords={seoConfig.keywords}
        ogType={seoConfig.ogType}
      />
      <PolicyLayout title="Terms of Use" lastUpdated="October 2025">
        <p>
          By using GelWel, you agree to these Terms of Use.
        </p>

        <h2>1. Eligibility</h2>
        <p>
          You must be 18 years or older to use GelWel.
        </p>

        <h2>2. Account Responsibilities</h2>
        <p>
          You are responsible for keeping your login credentials secure. Do not share your password with others.
        </p>

        <h2>3. Acceptable Use</h2>
        <p>You agree not to:</p>
        <ul>
          <li>Post harmful, abusive, or explicit content.</li>
          <li>Impersonate others or misrepresent yourself.</li>
          <li>Use GelWel for illegal activities or spam.</li>
        </ul>

        <h2>4. Content Ownership</h2>
        <p>
          You own the content you create. By uploading, you grant GelWel a non-exclusive license to display
          and distribute it within the platform.
        </p>

        <h2>5. Disclaimer</h2>
        <p>
          GelWel is provided "as is." We are not liable for damages arising from misuse, service interruptions,
          or third-party actions.
        </p>

        <h2>6. Termination</h2>
        <p>
          We may suspend or terminate accounts that violate these Terms or harm the community.
        </p>

        <h2>7. Contact</h2>
        <p>
          For legal or support inquiries:{' '}
          <a href="mailto:paulfortuneltd@gmail.com">paulfortuneltd@gmail.com</a>
        </p>
      </PolicyLayout>
    </>
  );
};

export default TermsOfUsePage;
